import { ItemTypeConsts } from 'client/util/Constants';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';

const GroupsMainPanel = () => import('client/components/MainPanel/GroupsMainPanel.vue');
const UserGroupAsidePanel = () => import('client/groups/User/UserGroupAsidePanel.vue');

const userGroupsProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.userGroup,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.userGroup,
    isAsideOpen: false,
    itemType: ItemTypeConsts.userGroup,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'User Groups',
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.userGroup].learnMoreUrl,
    pText: GettingStartedPanelSettings[ItemTypeConsts.userGroup].tooltipText,
  },
};

export default [
  {
    path: '/groups/user',
    name: 'UserGroups',
    meta: metaData,
    components: {
      mainPanel: GroupsMainPanel,
    },
    props: userGroupsProps,
  },
  {
    path: '/groups/user/membership/suggested/updates',
    name: 'userGroupsMembershipSuggestedUpdates',
    meta: metaData,
    components: {
      mainPanel: GroupsMainPanel,
    },
    props: userGroupsProps,
  },
  {
    path: '/groups/user/new',
    name: 'newUserGroup',
    meta: metaData,
    components: {
      mainPanel: GroupsMainPanel,
      asidePanel: UserGroupAsidePanel,
    },
    props: {
      mainPanel: userGroupsProps.mainPanel,
      asidePanel: route => ({
        ...userGroupsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/groups/user/:id/details',
    name: 'userGroupDetails',
    meta: metaData,
    components: {
      mainPanel: GroupsMainPanel,
      asidePanel: UserGroupAsidePanel,
    },
    props: {
      mainPanel: userGroupsProps.mainPanel,
      asidePanel: route => ({
        ...userGroupsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/groups/user/:id/details/:initialTab',
    name: 'userGroupInitialTab',
    meta: metaData,
    components: {
      mainPanel: GroupsMainPanel,
      asidePanel: UserGroupAsidePanel,
    },
    props: {
      mainPanel: userGroupsProps.mainPanel,
      asidePanel: route => ({
        ...userGroupsProps.asidePanel,
        itemId: route.params.id,
        navigateToTab: { tabLabel: route.params.initialTab },
      }),
    },
  },
];
